import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { commonDataGridStyles } from '../../styles/dataGridStyles';

const VendorsTable = ({ vendors, searchTerm }) => {
    // Filter vendors based on search term - only by vendor and vendorNo
    const filteredVendors = vendors.filter(vendor => {
        if (!searchTerm) return true;
        const search = searchTerm.toLowerCase();
        return (
            vendor.vendor?.toLowerCase().includes(search) ||
            vendor.vendorNo?.toLowerCase().includes(search)
        );
    });

    const columns = [
        {
            field: 'vendor',
            headerName: 'Vendor',
            flex: 1,
            minWidth: 300,
            renderCell: (params) => (
                <div style={{ 
                    fontWeight: 500,
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: 1.4
                }}>
                    {params.value || '-'}
                </div>
            )
        },
        {
            field: 'vendorNo',
            headerName: 'Vendor No',
            width: 200,
            renderCell: (params) => (
                <div style={{ 
                    color: '#666',
                    fontFamily: 'monospace'
                }}>
                    {params.value || '-'}
                </div>
            )
        }
    ];

    return (
        <DataGrid
            rows={filteredVendors}
            columns={columns}
            initialState={{
                pagination: {
                    paginationModel: { pageSize: 25 }
                }
            }}
            pageSizeOptions={[25, 50, 100]}
            disableSelectionOnClick
            getRowId={(row) => row.id}
            rowHeight={60}
            sx={commonDataGridStyles}
        />
    );
};

export default VendorsTable;